import React, { memo, useMemo } from "react";
import PropTypes from "kf-proptypes/widgets";

import { useUserStore } from "base/stores";

/**
 * This component is used to if this feature is present in account feature list render the children if not then does not render children
 */
function FeatureGateNormal(props) {
  const { features = [], shouldGate = () => null, children } = props;
  const userFeatures = useUserStore(
    (state) => state.currentUser.AccountDetails.Features
  );
  const slots = React.Children.map(children, (child) => child);
  const nonfallbackChildren = slots.filter(
    (child) => child.type !== FeatureGate.Fallback
  );
  const fallbackChildren = slots.filter(
    (child) => child.type === FeatureGate.Fallback
  );
  const supported = useMemo(
    function supportedCheck() {
      return (
        shouldGate(userFeatures) ||
        features.find((feature) => userFeatures.includes(feature))
      );
    },
    [features, userFeatures, shouldGate]
  );
  return supported ? nonfallbackChildren : fallbackChildren;
}
FeatureGateNormal.propTypes = {
  /** Feature should gate */
  features: PropTypes.arrayOf(PropTypes.string),
  /**
   * should Gate is overwrite the account list of feature a many function consumer can write their own logic to render children
   */
  shouldGate: PropTypes.func,
  /**
   * Children covered by the error boundary
   */
  children: PropTypes.node
};
FeatureGateNormal.defaultProps = {
  features: [],
  shouldGate: () => false
};
FeatureGateNormal.displayName = "FeatureGate";

export const FeatureGate = memo(FeatureGateNormal);

export function FeatureGateFallback(props) {
  return <React.Fragment>{props.children}</React.Fragment>;
}

FeatureGateFallback.propTypes = {
  children: PropTypes.node.isRequired
};

FeatureGate.Fallback = FeatureGateFallback;

export function hasFeatures(features) {
  const userFeatures =
    useUserStore.getState().currentUser?.AccountDetails.Features;
  let foundFeature = features.find((feature) =>
    userFeatures?.includes(feature)
  );
  return foundFeature;
}
